import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import React from 'react'
import CenteredLoadingSpinner from './CenteredLoadingSpinner'
import MinHeightDecorator from './MinHeightDecorator'

const navCss = css`
  height: 52px;
  background: ${colors.gray00};
`

export default function AppLoading() {
  return (
    <>
      <nav css={navCss} />
      <MinHeightDecorator>
        <CenteredLoadingSpinner />
      </MinHeightDecorator>
    </>
  )
}
